import { render, staticRenderFns } from "./HomeWelcomeView.vue?vue&type=template&id=a878395c&"
import script from "./HomeWelcomeView.vue?vue&type=script&lang=js&"
export * from "./HomeWelcomeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports